import Notecard from "./Notecard";

export default Notecard;
